import React from 'react';
import Leaderboard from "../components/Leaderboard/Leaderboard.jsx";

const RegistrationSuccess = () => {
  return (
    <div>
      <Leaderboard/>
    </div>
  );
};

export default RegistrationSuccess;